import React from "react";
import "./Css/TermsConditions.css";

const TermsConditions = () => {
  return (
    <div className="terms-page">

      <div className="terms-container">

        <h1 className="terms-title">Terms and Conditions</h1>

        <p>
          By using our website, you agree to the following terms:
        </p>

        <h2>Orders:</h2>
        <ul>
          <li>
            All orders are subject to product availability and confirmation.
          </li>
          <li>
            Prices listed include applicable taxes unless mentioned otherwise.
          </li>
        </ul>

        <h2>Payments:</h2>
        <ul>
          <li>
            We accept secure online payments via integrated payment gateways.
          </li>
          <li>
            Orders will be processed once payment is confirmed.
          </li>
        </ul>

        <h2>Product Information:</h2>
        <ul>
          <li>
            We make every effort to display accurate product details, dimensions, and colors.
          </li>
          <li>
            Actual product colors may slightly vary due to lighting and screen differences.
          </li>
        </ul>

        <h2>Use of Website:</h2>
        <p>
          You agree not to misuse the website or engage in unlawful activities.
        </p>

        <div className="terms-contact">
          <h3>For support, contact:</h3>
          <p>📧 akessoftware@gmail.com</p>
        </div>

      </div>

    </div>
  );
};

export default TermsConditions;